export const getFileName = (fullUrl) =>{
    let fpath = fullUrl;
    fpath = fpath.replace(/\\/g, '/');
    let fname = fpath.substring(fpath.lastIndexOf('/')+1, fpath.lastIndexOf('.'));
    return fname;
}
  